export default __webpack_public_path__ + "static/media/bkg--location-1.ffe9ad01.jpg";